import { Observable } from 'rxjs/Observable';
import { AuthService } from './auth.service';
import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {

  ARTEMISA_APP_HEADERS: string;

  constructor(private injector: Injector) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let _authService = this.injector.get(AuthService);
    let _tokenizedReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${_authService.getToken()}`
        // ,'Access-Control-Allow-Origin': 'http://localhost:4200'
        // ,"Access-Control-Allow-Headers": "*"
        // ,"Access-Control-Allow-Origin": "*"
      }
    });
    return next.handle(_tokenizedReq);
  }

}
